import { useMemo } from 'react';

import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './BarLoader.css';

const IconLoader = (props) => {
  const {
    size,
    rounded,
    className,
    id,
    style,
  } = props;

  const barLoaderClass = useMemo(() => {
    return classNames(
    {
    'gradient-animation': true,
    'h-10 w-10': isEqual('small', size),
    'rounded': isEqual('small', size) && rounded,
    'h-20 w-20': isEqual('regular', size),
    'rounded-xl': isEqual('regular', size) && rounded,
    'h-32 w-32': isEqual('large', size),
    'rounded-2xl': isEqual('large', size) && rounded,
  }, className);
}, [size, rounded, className]);

  return (
    <div
      id={id}
      style={style}
      className={barLoaderClass}
    />
  );
};

IconLoader.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['large', 'regular', 'small']),
  rounded: PropTypes.bool,
  style: PropTypes.object,
};

IconLoader.defaultProps = {
  id: '',
  className: '',
  size: 'regular',
  rounded: false,
  style: {},
};

export default IconLoader;
